import styled from 'styled-components';

export const WebTabContainer = styled.div`
  @media (min-width: 720px) {
    display: none;
  }
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 60px;
  background-color: #fff;
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 1000;
  border-top: 1px solid #e0e0e0;

  .webTabOptions {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 80%;
  }
`;

export const WebTabElements = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 8px;

  p {
    font-weight: bold;
    font-size: 9px;
    color: ${(props) => (props.isSelected ? '#000' : '#989898')};
    text-align: center;
    font-family: Montserrat;
    margin: 0;
  }

  .GetMyloApp {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: fixed;
    right: 0;
    bottom: 0;
    width: 18%;
    height: 45px;
    margin: 8px auto;
    background-color: #ef4e5e;
    border-top-left-radius: 12px;
    border-bottom-left-radius: 12px;

    p {
      margin: 0;
      color: #fff;
    }
  }
`;
